export class UnitValue {
  value?: number;
  unit?: string;

  constructor(value?: number, unit?: string) {
    this.value = value;
    this.unit = unit;
  }
}
